import {usePlaneduHttpService} from "../service/planedu.http.service";
import {FinancialClassEntity} from "../entity/financial-class.entity";

export function useFinancialClassRepository() {
    const httpService = usePlaneduHttpService<FinancialClassEntity>('financial-class');
    return {
        ...httpService,
    }
}